import React from "react";
import { Dropdown, Button } from "antd";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ActionFilter = ({
  index,
  onView,
  onEdit,
  onDelete,
  onUpdateAvailability,
  onEditStickers,
  badge,
  karaoke,
  dance,
  notification,
  word,
  feedback,
}) => {
  let items;

  if (badge) {
    items = [
      {
        label: <Button onClick={() => onEdit(index)}>Edit</Button>,
        key: "0",
      },
      {
        label: <Button onClick={() => onView(index)}>View</Button>,
        key: "2",
      },
    ];
  } else if (notification) {
    items = [
      {
        label: <Button onClick={() => onEdit(index)}>Edit</Button>,
        key: "0",
      },
      {
        label: <Button onClick={() => onDelete(index)}>Delete</Button>,
        key: "1",
      },
    ];
  } else if (karaoke) {
    items = [
      {
        label: <Button onClick={() => onEdit(index)}>Edit</Button>,
        key: "0",
      },
      {
        label: (
          <Button onClick={() => onUpdateAvailability(index)}>
            Update Availability
          </Button>
        ),
        key: "1",
      },
      // Quick sticker editor — skips the full lyric/sync edit flow
      ...(onEditStickers
        ? [
            {
              label: (
                <Button onClick={() => onEditStickers(index)}>
                  Edit Stickers
                </Button>
              ),
              key: "3",
            },
          ]
        : []),
      {
        label: <Button onClick={() => onDelete(index)}>Delete</Button>,
        key: "2",
      },
    ];
  } else if (dance) {
    items = [
      {
        label: <Button onClick={() => onEdit(index)}>Edit</Button>,
        key: "0",
      },
      {
        label: (
          <Button onClick={() => onUpdateAvailability(index)}>
            Update Availability
          </Button>
        ),
        key: "1",
      },
      {
        label: <Button onClick={() => onDelete(index)}>Delete</Button>,
        key: "2",
      },
    ];
  } else if (word) {
    items = [
      {
        label: <Button onClick={() => onDelete(index)}>Delete</Button>,
        key: "0",
      },
    ];
  } else if (feedback) {
    items = [
      {
        label: (
          <Button style={{ width: "100%" }} onClick={() => onView(index)}>
            View Details
          </Button>
        ),
        key: "0",
      },
      {
        label: (
          <Button style={{ width: "100%" }} onClick={() => onEdit(index)}>
            Toggle Resolution
          </Button>
        ),
        key: "1",
      },
      {
        label: (
          <Button style={{ width: "100%" }} onClick={() => onDelete(index)}>
            Delete
          </Button>
        ),
        key: "2",
      },
    ];
  } else {
    items = [
      {
        label: <Button onClick={() => onEdit(index)}>Edit</Button>,
        key: "0",
      },
      {
        label: <Button onClick={() => onDelete(index)}>Delete</Button>,
        key: "1",
      },
      {
        label: <Button onClick={() => onView(index)}>View</Button>,
        key: "2",
      },
    ];
  }

  return (
    <Dropdown
      placement="bottom"
      menu={{ items }}
      trigger={["click"]}
      overlayClassName="custom-dropdown-details"
    >
      <Button className="more-info-btn" onClick={(e) => e.preventDefault()}>
        <MoreVertIcon />
      </Button>
    </Dropdown>
  );
};

export default ActionFilter;
